import React, { Component, Fragment } from 'react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { MessageBars } from '../Outils/MessageBars';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import { DataFluxPartenaire } from '../../data/DataFluxPartenaire';

/*
***************************************************************
 PROPS: aucune
***************************************************************
*/

export class DetailsListFluxPartenaire extends Component {

    _creationContent = () => {
        return <Fragment>
            <DetailsListFluxEiffage />
            <CommandBar />
            <DetailsList
                columns={this._columns}
                items={this.state.items}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                selectionMode={SelectionMode.none}
            />
        </Fragment>
    }

    constructor(props) {
        super(props);

        this._columns = [
            {
                key: 'actif',
                minWidth: 12.5,
                maxWidth: 15,
                onRender: this._onRenderEstActif
            },
            {
                key: "partenaire",
                minWidth: 100,
                maxWidth: 200,
                name: "Partenaire",
                onRender: this._onRenderPartenaire
            },
            {
                key: "logsActualisation",
                minWidth: 125,
                maxWidth: 200,
                name: "Logs d'actualisation",
                onRender: this._onRenderLogsDropdown("logsActualisation")
            },
            {
                key: "logsAction",
                minWidth: 125,
                maxWidth: 200,
                name: "Logs d'actions",
                onRender: this._onRenderLogsDropdown("logsAction")
            },
            {
                key: "fluxStock",
                minWidth: 125,
                maxWidth: 200,
                name: "Flux de stock",
                onRender: (item) => {
                    const nomDuFlux = item.fluxStock;
                    return <Link onClick={this._telechargerDocument(item, "fluxStock", nomDuFlux)}>{nomDuFlux}</Link>
                }
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                key: "dateFluxStock",
                minWidth: 125,
                maxWidth: 200,
                name: "Date du dernier envoi",
                onRender: (item) => <span>{item.dateFluxStock}</span>
            },
            {
                key: "fluxOptions",
                minWidth: 125,
                maxWidth: 200,
                name: "Flux des options",
                onRender: (item) => {
                    const nomDuFlux = item.fluxOptions;
                    return <Link onClick={this._telechargerDocument(item, "fluxOptions", nomDuFlux)}>{nomDuFlux}</Link>
                }
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                key: "dateFluxOptions",
                minWidth: 125,
                maxWidth: 200,
                name: "Date du dernier envoi",
                onRender: (item) => <span>{item.dateFluxOptions}</span>
            }
        ];

        this.state = {
            items: [],
            /* ----- */
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: '',
        };
    }

    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des flux en cours'
            });

            DataFluxPartenaire._onChargementFluxPartenaire().then(responseFetch => {
                const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                let newState = {
                    enCoursDeTraitement: false,
                    messageEnCoursTraitement: '',
                    hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                    warningMessage: retourVerif.warningMessage,
                    hideMessageBarError: retourVerif.hideMessageBarError,
                    errorMessage: retourVerif.errorMessage
                };
                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                    newState.items = listeItem; // Charger les partenaires
                    newState.logsActualisationSelectionnes = {};
                    newState.logsActionSelectionnes = {};

                    for (let i = 0; i < listeItem.length; i++) { // Pour chacun des partenaires, fixer les valeurs par défaut des ComboBox
                        const item = listeItem[i];

                        const logsActualisation = item.logsActualisation; // ComboBox logs actualisation
                        if (logsActualisation && logsActualisation.length)
                            newState.logsActualisationSelectionnes[item.partenaire] = logsActualisation[0];

                        const logsAction = item.logsAction; // ComboBox logs action
                        if (logsAction && logsAction.length)
                            newState.logsActionSelectionnes[item.partenaire] = logsAction[0];
                    }
                };
                this.setState(newState);
            });
        }
    };

    _onChangeDropdown = (item, categorieDeLogs) => (event, option, index) => {
        let logsSelectionnes = { ...this.state[`${categorieDeLogs}Selectionnes`] }; // logsActualisatonSelectionnes ou logsActionSelectionnes
        logsSelectionnes[item.partenaire] = option.key;
        this.setState({ [`${categorieDeLogs}Selectionnes`]: logsSelectionnes });
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onRenderEstActif = (item) => {
        if (item.estActif) return <Icon iconName="FullCircleMask" styles={{ root: { color: "#107c10" } }} title="Actif" />;
        else return <Icon iconName="FullCircleMask" title="Inactif" />;
    };

    _onRenderPartenaire = (item) => {
        let nomPartenaire = item.partenaire.replace("(Desactive)", "");
        nomPartenaire = nomPartenaire.trim();
        return <span>{`${nomPartenaire} (V${item.version})`}</span>
    };

    _onRenderLogsDropdown = (categorieDeLogs) => (item) => {
        let options = [];
        const logs = item[categorieDeLogs] || []; // logsActualisaton ou logsAction

        for (let i = 0; i < logs.length; i++) {
            const logTitle = logs[i];
            options[i] = { key: logTitle, text: logTitle };
        }

        return options.length ? <Stack horizontal>
            <Dropdown
                defaultSelectedKey={this.state[`${categorieDeLogs}Selectionnes`][item.partenaire]} // Exemple : this.state.logsActionSelectionnes.emerson
                options={options}
                onChange={this._onChangeDropdown(item, categorieDeLogs)}
                styles={{ root: { minWidth: "85%", maxWidth: "85%" } }}
            />
            <IconButton
                ariaLabel="Télécharger"
                iconProps={{ iconName: "Download" }}
                onClick={this._telechargerLog(item, categorieDeLogs)}
                title="Télécharger"
            />
        </Stack> : null;
    };

    _telechargerLog = (item, categorieDeLogs) => {
        const nomDuFichier = this.state[`${categorieDeLogs}Selectionnes`][item.partenaire];
        return this._telechargerDocument(item, categorieDeLogs, nomDuFichier);
    };

    _telechargerDocument = (item, categorieDeDocuments, nomDuFichier) => () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Téléchargement du document en cours..."
            });

            DataFluxPartenaire._onTelechargementDocument(item.version, item.partenaire, categorieDeDocuments, nomDuFichier).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this.setState({
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: ""
                    });
                    const objetData = responseFetch.reponseAPIobjet;
                    const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                    return Scriba.fichier().EnregisterSous(document, objetData.nom);
                }
                else
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            });
        }
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>
            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>
        </Fragment>
    };
};

class DetailsListFluxEiffage extends Component {

    constructor(props) {
        super(props);

        this._columns = [
            {
                key: 'actif',
                minWidth: 12.5,
                maxWidth: 15,
                onRender: () => <Icon iconName="FullCircleMask" styles={{ root: { color: "#107c10" } }} title="Actif" />
            },
            {
                key: "fluxEiffage",
                minWidth: 100,
                maxWidth: 200,
                name: "Flux EIFFAGE",
                onRender: () => <span>Site Web EIFFAGE</span>
            },
            {
                key: "logs",
                minWidth: 125,
                maxWidth: 200,
                name: "Logs",
                onRender: this._onRenderLogsEiffageDropdown
            },
            {
                key: "fluxSiteWeb",
                minWidth: 125,
                maxWidth: 200,
                name: "Flux",
                onRender: (item) => {
                    const nomDuFlux = item.fluxSiteWeb;
                    return <Link onClick={this._telechargerDocumentFluxEiffage(nomDuFlux)}>{nomDuFlux}</Link>
                }
            },
            {
                key: "dateFluxSiteWeb",
                minWidth: 125,
                maxWidth: 200,
                name: "Date du dernier envoi",
                onRender: (item) => <span>{item.dateFluxSiteWeb}</span>
            }
        ];

        this.state = {
            items: [],
            /* ----- */
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: '',
        };
    }

    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Chargement du flux Eiffage en cours"
            });

            DataFluxPartenaire._onChargementFluxEiffage().then(responseFetch => {
                const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                let newState = {
                    enCoursDeTraitement: false,
                    messageEnCoursTraitement: '',
                    hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                    warningMessage: retourVerif.warningMessage,
                    hideMessageBarError: retourVerif.hideMessageBarError,
                    errorMessage: retourVerif.errorMessage
                };
                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    const items = responseFetch.reponseAPIobjet;
                    newState.items = items;
                    newState.logSelectionne = "";

                    if (items && items.length > 0) {
                        const logs = items[0].logs;
                        if (logs && logs.length)
                            newState.logSelectionne = logs[0];
                    }
                };
                this.setState(newState);
            });
        }
    };

    _onChangeDropdown = (event, option, index) => {
        this.setState({ logSelectionne: option.key });
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onRenderLogsEiffageDropdown = (item) => {
        let options = [];
        const logs = item.logs || [];

        for (let i = 0; i < logs.length; i++) {
            const logTitle = logs[i];
            options[i] = { key: logTitle, text: logTitle };
        }

        return options.length ? <Stack horizontal>
            <Dropdown
                defaultSelectedKey={this.state.logSelectionne}
                options={options}
                onChange={this._onChangeDropdown}
                styles={{ root: { width: "85%" } }}
            />
            <IconButton
                ariaLabel="Télécharger"
                iconProps={{ iconName: "Download" }}
                onClick={this._telechargerDocumentFluxEiffage()}
                title="Télécharger"
            />
        </Stack> : null;
    };

    _telechargerDocumentFluxEiffage = (nomDuFichier) => () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Téléchargement du document en cours..."
            });

            // Si nomDuFichier n'est pas défini alors on utilise la valeur stockée dans le state
            DataFluxPartenaire._onTelechargementDocumentFluxEiffage(nomDuFichier || this.state.logSelectionne).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this.setState({
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: ""
                    });
                    const objetData = responseFetch.reponseAPIobjet;
                    const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                    return Scriba.fichier().EnregisterSous(document, objetData.nom);
                }
                else
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            });
        }
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => <DetailsList
        columns={this._columns}
        items={this.state.items}
        onRenderDetailsHeader={this._onRenderDetailsHeader}
        selectionMode={SelectionMode.none}
    />

}